import { IHixUploadItem } from "../../../src/taskpane/interfaces/IHix";
import { getFileItemIdFromRelativePath, getItemWebViewUrl } from "../../../src/taskpane/services/GraphService";
import { SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { OneNoteProgId } from "../../../src/taskpane/config/constants";
import authModule from "../../../utilities/AuthModule";

// Mirrors the content-manager download resolution (useMenuItem_Download): the drive id comes
// from the current directory (or the OneDrive root), and the Graph item id is parsed from the
// row's '.spItemUrl' with a relative-path fallback. Folders / non-file rows are excluded.
export const isCmUploadableFile = (item: any): boolean => {
  if (!item) return false;
  if (item.File_x0020_Type === "url") return false;
  if (item.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder)) return false;
  if (item.ProgId === OneNoteProgId) return false;
  return true;
};

export const resolveCmHixUploadItems = async (
  selectedItems: any[],
  currentDirectory: any,
  oneDriveRootDetails: any,
  isInOneDrive: boolean
): Promise<IHixUploadItem[]> => {
  const files = (selectedItems ?? []).filter(isCmUploadableFile);

  const driveId = !isInOneDrive
    ? (!currentDirectory?.parentId ? currentDirectory?.id : currentDirectory?.parentId)
    : oneDriveRootDetails?.driveId;

  return Promise.all(files.map(async (item) => {
    const spItemUrl: string = item[".spItemUrl"];
    const spItemUrlParts: string[] = spItemUrl ? spItemUrl.split("/") : [];
    let itemId: string = spItemUrlParts.length > 0 ? spItemUrlParts[spItemUrlParts.length - 1].split("?")[0] : "";

    if (!itemId) {
      const accessToken = await authModule.getGraphAccessToken();
      const driveUrl = new URL(await getItemWebViewUrl(accessToken, driveId, null));
      const folderUrl = new URL(driveUrl.origin + item.FileRef);
      itemId = await getFileItemIdFromRelativePath(accessToken, driveId, folderUrl.pathname.replace(driveUrl.pathname, ""), false);
    }

    return {
      driveId,
      itemId,
      name: item.FileLeafRef,
    } as IHixUploadItem;
  }));
};
